window.storage = {
  set: async (key, value) => {
    try { localStorage.setItem('ew_' + key, value); return { key, value }; }
    catch (e) { return null; }
  },
  get: async (key) => {
    try { const value = localStorage.getItem('ew_' + key); return value !== null ? { key, value } : null; }
    catch (e) { return null; }
  },
  delete: async (key) => {
    try { localStorage.removeItem('ew_' + key); return { key, deleted: true }; }
    catch (e) { return null; }
  },
  list: async (prefix) => {
    try { const keys = Object.keys(localStorage).filter(k => k.startsWith('ew_' + (prefix || ''))).map(k => k.replace('ew_', '')); return { keys }; }
    catch (e) { return { keys: [] }; }
  }
};